import { IoTrashOutline, IoWarningOutline } from "react-icons/io5";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useI18n } from "@/i18n";
import { tapMedium } from "@/utils/haptics";

export const ConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  title,
  description,
  confirmLabel,
  danger = true,
  Icon = IoTrashOutline,
}) => {
  const { t } = useI18n();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="confirm-dialog" className="max-w-sm p-0" style={{ borderRadius: 20 }}>
        <div className="tf-modal-content">
          <div className="tf-modal-icon">
            <Icon size={36} />
          </div>
          <div className="tf-modal-title">{title}</div>
          <p className="tf-modal-desc">{description}</p>
          <button
            data-testid="confirm-dialog-confirm"
            className="tf-btn-primary sq"
            onClick={() => { tapMedium(); onConfirm(); onOpenChange(false); }}
          >
            <Icon size={18} />
            {confirmLabel || t("delete")}
          </button>
          <button data-testid="confirm-dialog-cancel" className="tf-modal-cancel" onClick={() => onOpenChange(false)}>
            {t("cancel")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
